import React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { useUserProfile } from 'client/app/hooks/useUserProfile';

type Props = {
  title: string;
  description: string;
  creationDate: string;
};

const ExperimentHeader: React.FC<Props> = ({ title, description, creationDate }) => {
  const userProfile = useUserProfile();

  return (
    <Box m={8}>
      <Typography variant="h2" gutterBottom>
        {title}
      </Typography>

      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        flexWrap="wrap"
      >
        <Box flexBasis={{ xs: '100%', sm: '50%' }} pr={2}>
          <Typography variant="subtitle2" color="textSecondary" mb={1}>
            Description
          </Typography>
          <Typography variant="body1">{description}</Typography>
        </Box>

        <Box flexBasis={{ xs: '50%', sm: '25%' }} pr={2}>
          <Typography variant="subtitle2" color="textSecondary" mb={1}>
            Creation Date
          </Typography>
          <Typography variant="body1">{creationDate}</Typography>
        </Box>

        <Box flexBasis={{ xs: '50%', sm: '25%' }}>
          <Typography variant="subtitle2" color="textSecondary" mb={1}>
            Creator
          </Typography>
          <Typography variant="body1">{userProfile?.displayName}</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ExperimentHeader;
